import { PROPOSAL_STATUSES } from "src/app/configs/constants";

export default function useCheckEndedProposal(proposal) {
  return proposal.status !== PROPOSAL_STATUSES.ACTIVE && proposal.status !== PROPOSAL_STATUSES.UPCOMING;
}